import React, { useState, useEffect, useCallback } from 'react';
import { Icon, Menu, Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { dayConversion, monthConversion } from '../../utils/javascript';
import { INTERACTIVE_TEMPLATES_LIST } from './translationValues';
import { TemplatePageOverview, TemplateImage, DropdownDetails } from './styles';

const THUMBNAIL_KEY = 'thumbnailUrl';
const NAMESPACES = ['INTERACTIVE_TEMPLATES_LIST'];

const InteractiveTemplate = props => {
  const { t } = useTranslation(NAMESPACES);
  const { templateObj, categoriesTemp, redirectToTemplate } = props;
  const [firstPageImageLink, setFirstPageImageLink] = useState(
    templateObj[THUMBNAIL_KEY] ? templateObj[THUMBNAIL_KEY] : undefined,
  );
  const [loading, setLoading] = useState(true);

  const onImageError = useCallback(() => {
    setFirstPageImageLink(undefined);
    setLoading(false);
  }, []);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <div key={templateObj.encodedId}>
      <div className="test">
        <TemplatePageOverview
          key={templateObj.id}
          title={templateObj.interactiveName}
          onClick={() => redirectToTemplate(templateObj)}
        >
          <TemplateImage className={loading ? 'show-loader' : ''}>
            <div className="image-wrapper">
              <div key={templateObj.categoryId} className="preview-image-div">
                <img
                  src={firstPageImageLink ? firstPageImageLink : PageNotFoundIllustration}
                  alt="pageObj-thumbnail"
                  className={!firstPageImageLink ? 'no-thumbnail' : ''}
                  onError={onImageError}
                  onLoad={onLoad}
                />
              </div>
            </div>
            <DropdownDetails
              id={`${templateObj.encodedId}-template`}
              className="dropdown-menu"
              onClick={e => e.stopPropagation()}
            >
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="0" onClick={() => redirectToTemplate(templateObj)}>
                      {t(
                        INTERACTIVE_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.key,
                        INTERACTIVE_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
                getPopupContainer={() => document.getElementById(`${templateObj.encodedId}-template`)}
              >
                <Icon type="more" />
              </Dropdown>
            </DropdownDetails>
          </TemplateImage>
          <div className="template_name">
            <div className="name" onClick={() => redirectToTemplate(templateObj)}>
              {templateObj.interactiveName}{' '}
            </div>
            <div className="categoryName">
              <div className="box2"></div>
              {categoriesTemp.length > 0 &&
                categoriesTemp.map(category => (
                  <div key={category.categoryId}>
                    {templateObj.categoryId === category.categoryId && category.categoryName}
                  </div>
                ))}
            </div>

            {(templateObj.updatedOn || templateObj.createdOn) && (
              <div className="template_date">
                <p>
                  {templateObj.updatedOn
                    ? dayConversion(templateObj.updatedOn)
                    : dayConversion(templateObj.createdOn)}
                </p>
                <p className="month">
                  {templateObj.updatedOn
                    ? monthConversion(templateObj.updatedOn)
                    : monthConversion(templateObj.createdOn)}
                </p>
              </div>
            )}
          </div>
        </TemplatePageOverview>
      </div>
    </div>
  );
};

export default InteractiveTemplate;
